import Component from '../abstracts/Component';
import {html} from 'htm/preact';
import algoliasearch from 'algoliasearch';
import {getAlgoliaResults} from '@algolia/autocomplete-preset-algolia';
import {autocomplete} from '@algolia/autocomplete-js';
import '@algolia/autocomplete-theme-classic';

export default class SearchLayerComponent extends Component {

  get SELECTORS() {
    return {
      closeSearchBtn: '[data-close-search]',
      searchLayer: '[data-search-layer]',
      searchInput: '#search_field_box input',
      searchIcon: '.js-search-icon',
      submitIcon: '.js-submit-icon',
      isSaleMode: 'data-search-sale',
      searchForm: '[data-search-form]',
      topSearchesWrapper: '.search-bar__prefill',
      currentLocale: '[data-search-currentLocale]',
      querySuggestionsWrapper: '#query-suggestions__wrapper',

      //algolia disabled
      searchInputField: "#searchInput",
      submitBtn: "[data-search-submit]",
    };
  }

  get CONST() {
    return {
      baseUrl: 'https://query-suggestions.eu.algolia.com',
      baseUri: '/1/configs',
      indexName: '/'
    }
  }

  constructor(compEl) {
    super(compEl);
    this.isSaleMode = this.$component.getAttribute(this.SELECTORS.isSaleMode);
    this.searchForm = this.$component.querySelector(this.SELECTORS.searchForm);
    this.searchInput = this.$component.querySelector(this.SELECTORS.searchInput);
    this.searchIcon = this.$component.querySelector(this.SELECTORS.searchIcon);
    this.searchFormUrlJs = this.searchForm.getAttribute('data-js-search-url');
    this.searchIndex = this.$component.getAttribute('data-search-index');
    this.appID = this.$component.getAttribute('data-search-appID');
    this.apiKey = this.$component.getAttribute('data-search-apiKey');
    this.analyticsApiKey = this.$component.getAttribute('data-search-analyticsApiKey');
    this.currentLocale = this.$component.getAttribute('data-search-currentLocale');
    this.topSearchesWrapper = document.querySelector(this.SELECTORS.topSearchesWrapper);
    this.closeSearchBtn = this.$component.querySelector(this.SELECTORS.closeSearchBtn);
    this.querySuggestionsWrapper = this.$component.querySelector(this.SELECTORS.querySuggestionsWrapper);
    this.isAlgoliaAutocompleteEnabled = this.$component.attributes['data-algolia-enabled'].nodeValue === 'true' && this.$component.attributes['data-search-suggestions'].nodeValue === 'true';
    this.submitLabel = this.$component.getAttribute('data-search-label-submit');

    //algolia disabled
    this.searchInputField = this.$component.querySelector(this.SELECTORS.searchInputField);
    this.submitBtn = this.$component.querySelector(this.SELECTORS.submitBtn);

  }

  readDOM() {
    return {
      closeSearchBtn: this.$component.querySelector(this.SELECTORS.closeSearchBtn),
      searchLayer: document.querySelector(this.SELECTORS.searchLayer),
    }
  }

  // HANDLE CLOSE LAYER //
  bindCloseSearchLayerEvents() {
    if (this.dom.closeSearchBtn && this.dom.searchLayer) {
      this.dom.closeSearchBtn.addEventListener("click", () => {
        this.closeSearchLayer();
      });

    document.addEventListener("keydown", (e) => {
      if  (e.key === "Escape" || e.key === "Esc" && this.dom.searchLayer.classList.contains("--opened"))  {
        e.preventDefault();
        this.closeSearchLayer();
      }
    });
    }
  }

  closeSearchLayer() {
    if (this.dom.searchLayer) {
      this.dom.searchLayer.classList.remove("--opened");
      // communication popup timer interaction //
      this.$emit(this.$customEvents.POPUP_EVENTS.resumeTimer);
      document.body.dataset.jsLayerIsOpen = "false";
      if (window.matchMedia('(max-width: 768px)').matches) {
        document.body.classList.remove("--no-overflow");
        const benefitBars = document.querySelectorAll("[data-benefit-bar]");
        if (benefitBars) {
          benefitBars.forEach(benefitBar => {
            benefitBar.classList.remove("hidden");
          });
        }
      }
    }
  }

  getSuggestion(index, search = false) {
    let ctx = this;
    // X-Algolia-Application-Id: the application ID.
    // X-Algolia-API-Key: the admin API key for given application ID.
    const appId = this.appID;
    const apiKey = this.apiKey;
    const searchClient = algoliasearch(appId, apiKey);
    let announceTimeout;
    //
    autocomplete({
      debug: true,
      container: '#l-s__search',
      panelContainer: '#l-s__suggestions',
      panelPlacement: 'full-width',
      placeholder: ctx.$component.dataset.searchPlaceholder,
      detachedMediaQuery: 'none',
      classNames: {
        clearButton: 'custom-button icon-chevron-right --s js-search-icon',
        submitButton: 'custom-button icon-search --m js-submit-icon'
      },
      getSources({query}) {
        return [
          {
            sourceId: 'querySuggestions',
            getItems() {
              return getAlgoliaResults({
                searchClient,
                queries: [
                  {
                    indexName: index,
                    query,
                    params: {
                      hitsPerPage: 4,
                    },
                  },
                ]
              });
            },
            getItemUrl({item}) {
              return item.url;
            },
            getItemInputValue({item}) {
              return item.query;
            },
            templates: {
              item({item}) {
                ctx.$component.querySelector(".aa-Panel").classList.remove("hidden");
                ctx.$component.classList.add("--has-results");
                ctx.$component.querySelector('#no-results').classList.add("hidden");
                ctx.$component.querySelector(ctx.SELECTORS.searchIcon).classList.add("active");
                const options = {style: "currency", currency: item.currency, maximumFractionDigits: 2};
                let itemHtml;
                if (item.name === 'CARTAREGALO') {
                  itemHtml = html`
                    <div class="c-product-card">
                      <a href="${item.link}" class="product-card__wrapper">
                        <div class="product-card__img-container">
                          <img class="product-card__img__main" src="${item.image_index}" alt=""/>
                        </div>
                        <div class="product-card__info-container product-card__info-container-name">
                          <h2 class="product-card__name">${item.title}</h2>
                        </div>
                      </a>
                    </div>`;
                } else if ((ctx.isSaleMode || item.specialPrice) && item.sale_price !== '' && item.isInSales === true) {
                  const originalPrice = item.price.toLocaleString(ctx.currentLocale, options);
                  const salePrice = item.sale_price.toLocaleString(ctx.currentLocale, options);
                  itemHtml = html`
                    <div class="c-product-card">
                      <div class="product-card__wrapper">
                        <div class="product-card__images__wrapper">
                          <a href="${item.link}" class="product-card__images">
                            <div class="product-card__picture">
                              <img src="${item.image_index}" alt="${item.title}"/>
                            </div>
                          </a>
                        </div>
                        <div class="product-card__info__wrapper">
                          <div class="product-card__info__text">
                            <a href="${item.link}">
                              <p class="product-card__collection">${item.collectionLabel}</p>
                            </a>
                            <a href="${item.link}">
                              <h2 class="product-card__name">${item.title}</h2>
                            </a>
                            <div class="product-card__info-container product-card__info-container-price">
                              <span class="product-card__price price-full">${originalPrice}</span>
                              <span class="product-card__price price-discount">${salePrice}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>`;
                } else if (!item.isPurchasable) {
                  itemHtml = html`
                    <div class="c-product-card">
                      <div class="product-card__wrapper">
                        <div class="product-card__images__wrapper">
                          <a href="${item.link}" class="product-card__images">
                            <div class="product-card__picture">
                              <img src="${item.image_index}" alt="${item.title}"/>
                            </div>
                          </a>
                        </div>
                        <div class="product-card__info__wrapper">
                          <div class="product-card__info__text">
                            <a href="${item.link}">
                              <p class="product-card__collection">${item.collectionLabel}</p>
                            </a>
                            <a href="${item.link}">
                              <h2 class="product-card__name">${item.title}</h2>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>`;

                } else {
                  const originalPrice = item.price.toLocaleString(ctx.currentLocale, options);
                  itemHtml = html`
                    <div class="c-product-card">
                      <div class="product-card__wrapper">
                        <div class="product-card__images__wrapper">
                          <a href="${item.link}" class="product-card__images">
                            <div class="product-card__picture">
                              <img src="${item.image_index}" alt="${item.title}"/>
                            </div>
                          </a>
                        </div>
                        <div class="product-card__info__wrapper">
                          <div class="product-card__info__text">
                            <a href="${item.link}">
                              <p class="product-card__collection">${item.collectionLabel}</p>
                            </a>
                            <a href="${item.link}">
                              <h2 class="product-card__name">${item.title}</h2>
                            </a>
                            <div class="product-card__info-container product-card__info-container-price">
                              <span class="product-card__price price-full">${originalPrice}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>`;
                }
                return itemHtml;
              },
              noResults() {
                ctx.$component.querySelector('#no-results').classList.remove("hidden");
                ctx.$component.querySelector(".aa-Panel").classList.add("hidden");
                ctx.$component.classList.remove("--has-results");
                return '';
              },
            },
          },
        ];
      },
      onSubmit() {
        ctx.jsSearchPage();
      },
      onReset({event}) {
        event.preventDefault();
        event.stopImmediatePropagation();
        event.stopPropagation();
        ctx.jsSearchPage();
      },
      onStateChange({state}) {
        clearTimeout(announceTimeout);

        const announcer = document.getElementById('live-search-announcer');
        if (!announcer) return;

        const hits = state.collections[0]?.items || [];
        const query = state.query || '';

        if (!query.trim()) {
          announcer.textContent = '';
          return;
        }

        const label = announcer.dataset.label;
        const empty = announcer.dataset.empty;

        announceTimeout = setTimeout(() => {
          if (hits.length === 0) {
            announcer.textContent = `${empty} "${query}".`;
          } else {
            announcer.textContent = `${hits.length} ${label} "${query}".`;
          }
        }, 3000);
      }
    });
  }

  bindAlgoliaSearch() {
    const index = this.$component.dataset.searchIndex;
    this.querySuggestionsWrapper.classList.remove("hidden");
    this.getSuggestion(index);
  }

  bindSolrSearch() {
    if (this.searchInputField && this.submitBtn) {
      this.submitBtn.classList.remove("active");
      this.searchInputField.addEventListener("input", event => {
        if (event.target.value.length === 0) {
          this.submitBtn.classList.remove("active");
        } else {
          this.submitBtn.classList.add("active");
        }
      });
    }
  }

  jsSearchPage() {
    // get autocomplete value
    let autocompleteInput = this.$component.querySelector(this.SELECTORS.searchInput);
    // build url
    let url = this.searchFormUrlJs + '?text=' + encodeURIComponent(autocompleteInput.value);
    // go to url
    window.location.href = url;
  }

  bindEvents() {
    let ctx = this;

    let searchInput = ctx.$component.querySelector(ctx.SELECTORS.searchInput);
    let searchIcon = ctx.$component.querySelector(ctx.SELECTORS.searchIcon);
    let submitIcon = ctx.$component.querySelector(ctx.SELECTORS.submitIcon);

    // handle layer close
    this.bindCloseSearchLayerEvents();

    // if suggestions are enabled, i want to keep the standard search working
    this.searchForm.addEventListener('submit', (e) => {
      e.preventDefault();
      this.jsSearchPage();
    });


    if (searchInput && searchIcon) {

      if (this.isAlgoliaAutocompleteEnabled) {
        // a11y for plugin html
        searchIcon.setAttribute("title", this.submitLabel);
        submitIcon?.setAttribute("title", this.submitLabel);
        searchIcon.setAttribute("aria-label", this.submitLabel);
        submitIcon?.setAttribute("aria-label", this.submitLabel);
      }

      searchInput.addEventListener("keyup", (event) => {
        if (searchInput.value == '') {
          searchIcon.classList.remove("active");
        }
      });
      searchIcon.addEventListener("click", (e) => {
        e.preventDefault();
        this.jsSearchPage();
      });
    }

    this.$on(this.$customEvents.MENU_EVENTS.showMenu, () => {
      this.dom.searchLayer.classList.remove("--opened");
    });
  }

  topSearchTemplate(search) {
    let searchEl = document.createElement("div");
    searchEl.classList.add("search-bar__category", "search-bar__subtitle");
    let searchLink = document.createElement("a");
    searchLink.href = "/search?text=" + encodeURIComponent(search);
    searchLink.innerHTML = search;
    searchEl.appendChild(searchLink);
    return searchEl;
  }


  render() {
    super.render();
    this.dom = this.readDOM();
    // if is enabled
    if (this.isAlgoliaAutocompleteEnabled) {
      this.bindAlgoliaSearch();
    } else {
      this.bindSolrSearch();
    }
    this.bindEvents();
  }
}
